module.exports = __webpack_public_path__ + "static/media/certificados.27a4729b.svg";